<template>
  <v-card class="dash_main_banner_card" elevation="0">
    <v-row>
      <v-col>
        <h2 class="mb-3">{{ $store.getters.t('스트림온 비디오 플랫폼') }}</h2>
        <v-row>
          <v-col style="line-height: 30px;">
            {{ $store.getters.t('스트림온은 VOD와 라이브 서비스 및 동영상 컨텐츠 관리를 위해') }}<br>
            {{ $store.getters.t('미디어서버, 인코더, 스토리지, CDN이 통합된 솔루션 입니다.') }}
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col style="color: #0066cc;font-weight: bold;">
            <router-link v-show="vod" to="/vod-manual" target="_blank">
              <v-chip link label color="#eee" style="color: #0066cc;">
                {{ $store.getters.t('VOD 사용법') }}
              </v-chip>
            </router-link>
            <router-link v-show="hls" to="/live-manual" target="_blank">
              <v-chip class="ml-2" link label color="#eee" style="color: #0066cc;">
                {{ $store.getters.t('HLS LIVE 사용법') }}
              </v-chip>
            </router-link>
            <router-link v-show="webrtc" to="/live-webrtc-manual" target="_blank">
              <v-chip class="ml-2" link label color="#eee" style="color: #0066cc;">
                {{ $store.getters.t('WEBRTC LIVE 사용법') }}
              </v-chip>
            </router-link>
          </v-col>
        </v-row> -->

        <v-row>
          <a :href="moveToManual" target="_blank" rel="noopener">
              <v-chip link label color="#eee" style="color: #0066cc;">
                <v-icon class="mr-2" small>mdi-file-document-outline</v-icon>
                {{ $store.getters.t('매뉴얼') }}
              </v-chip>
          </a>
        </v-row>
      </v-col>
      <v-col class="pa-0 mt-4">
        <v-img src="../../styles/dashboard/dash_images.png" width="300" style="margin-left: auto;"></v-img>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "DashboardHeader",
  computed: {
    vod() {
        return this.$store.state.naviList.allowList.vod;
    },
    hls() {
        return this.$store.state.naviList.allowList.hls;
    },
    webrtc() {
        return this.$store.state.naviList.allowList.webrtc;
    },
    moveToManual(){
      const lang = this.$store.getters.currentLanguage;
      let temp;
      if(lang == 'KOR'){
        temp = 'kr';
      } else if(lang == 'ENG'){
        temp = 'en';
      } else if(lang == 'CHN'){
        temp = 'cn';
      } else if(lang == 'JPN'){
        temp = 'jp';
      }

      const versionNum = process.env.VUE_APP_VERSION ?? '1_0';

      const url = this.$store.getters.t('manual_url')  + '/' + versionNum + '/' + temp;
    
      // console.log("url => ", url);

      return url;
    }
  },

}
</script>

<style lang="scss" scoped></style>

